module.exports = __webpack_public_path__ + "img/6.aaba1e50.png";